import { useTranslation } from "react-i18next";
import parse, { Element, HTMLReactParserOptions } from "html-react-parser";
interface TemplateData {
  id: string;
  html: string;
  css: string;
}
export const renderTemplate = (templateData: string, isAuthenticated?: boolean): React.ReactNode => {
  if (templateData) {
    try {
      const parsedData: TemplateData = JSON.parse(templateData);
      const { html, css } = parsedData;
      // Create and append style element
      const style = document.createElement("style");
      style.innerHTML = css;
      document.head.appendChild(style);

      // Parse and replace HTML
      const options: HTMLReactParserOptions = {
        replace: (domNode) => {
          const element = domNode as Element;
          if (element.attribs && element.attribs["component-class"]) {
            switch (element.attribs["component-class"]) {
              case "case":
                return "a";
              default:
                return null;
            }
          }
          return undefined;
        },
      };

      return parse(html, options);
    } catch (error) {
      console.error("Error parsing template data:", error);
      return null;
    }
  }
  return null;
};
